import React, { useEffect, useState } from 'react'
import './layouts.css'
import Sidebar from './Sidebar'
import { Link, Navigate, Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import TopBar from './TopBar'
import { atenyaUser, errorMessage, loginTypeConst, LoginTypeConstObj } from 'constant/const'
import { useDispatch, useSelector } from 'react-redux'
import { jwtTokenVerify } from 'utils/jwtTokenVerify'
import { toastError } from 'utils/toastify'
import { logoutAction, setUserDataLocal } from 'store/action/AuthRedux'
import {
   getAllChannelListAction,
   setSelectChannelId,
   setUserType
} from 'store/action/settingsReducer'
import { CustomModal, Loader } from 'components'
import axiosInstance from 'utils/axiosConfig'
import { convertObjectToFormData } from 'utils/convertFormData'

export default function Layout() {
   const authData = useSelector((state) => state.user)
   const { userData, addChannel, loginType } = authData
   const [isMini, setIsMini] = useState(true)
   const navigate = useNavigate()
   const dispatch = useDispatch()
   const [searchParams, setSearchParams] = useSearchParams()
   const [openPrivacyPolicyModal, setOpenPrivacyPolicyModal] = useState(false)
   const [isShowMobileMenu, setIsShowMobileMenu] = useState(false)
   const onMobileMenu = () => {
      setIsShowMobileMenu(!isShowMobileMenu)
   }

   const onMiniSidebar = () => {
      setIsMini(!isMini)
   }
   const settingData = useSelector((state) => state.settings)
   const { selectedUserTypes, selectedChannelID, loading, channelListLoading } = settingData
   const location = useLocation()
   const [isLoading, setIsLoading] = useState(false)

   const getParams = new URLSearchParams(location.search)

   useEffect(() => {
      dispatch(setUserType(getParams.get('userType') || selectedUserTypes))
      dispatch(setSelectChannelId(getParams.get('channel_id') || selectedChannelID))
      window.scrollTo(0, 0)
      return () => {}
   }, [location])

   useEffect(() => {
      if (userData) {
         setSearchParams({
            userType: selectedUserTypes,
            channel_id: selectedChannelID
         })
      }

      return () => {}
   }, [selectedUserTypes, selectedChannelID, userData])

   useEffect(() => {
      if (userData && getParams.get('userType')) {
         dispatch(getAllChannelListAction({ user_type: getParams.get('userType') }))
      }
      return () => {}
   }, [getParams.get('userType'), userData])

   useEffect(() => {
      if (loginType === LoginTypeConstObj.google && userData && userData?.access) {
         if (!userData?.is_channel_exists) {
            navigate('/auth/add-channel')
         } else if (!userData?.is_privacy_checked) {
            setOpenPrivacyPolicyModal(true)
         } else {
            let logOutUser = jwtTokenVerify(userData)
            if (logOutUser) {
               toastError('Session timeout, please login again.')
               setTimeout(() => {
                  dispatch(logoutAction())
               }, 1000)
            }
         }
      } else if (loginType === LoginTypeConstObj.instagram) {
         navigate('/instagram/dashboard')
      }
      return () => {}
   }, [userData, loginType])

   const onClickReadPrivacyPolicy = async (e) => {
      try {
         setIsLoading(true)
         let formData = convertObjectToFormData({
            is_privacy_checked: true
         })
         let res = await axiosInstance.post('/user/user-update/', formData, {
            headers: {
               Authorization: `Bearer ${userData?.access}`
            }
         })
         console.log('res.data', res.data)
         if (res.data?.data) {
            let data = { ...userData, is_privacy_checked: true }
            dispatch(setUserDataLocal(data))
            setOpenPrivacyPolicyModal(false)
         }
         setIsLoading(false)
      } catch (err) {
         setIsLoading(false)
         console.log(err)
         toastError(errorMessage)
      }
   }

   let user = localStorage.getItem(atenyaUser)
   let lType = localStorage.getItem(loginTypeConst)

   if (!user) {
      return <Navigate to={'/auth/login'} />
   } else if (lType === LoginTypeConstObj.instagram) {
      return <Navigate to={'/instagram/dashboard'} />
   }

   return (
      <>
         {(loading || isLoading || channelListLoading) && <Loader />}
         <div className="template-pages">
            <TopBar isMini={isMini} onMobileMenu={onMobileMenu} />
            <Sidebar
               isMini={isMini}
               onMiniSidebar={onMiniSidebar}
               isShowMobileMenu={isShowMobileMenu}
               onMobileMenu={onMobileMenu}
            />
            <div className="main-content"></div>
            <div className={`atenya-content ${!isMini ? 'more-spach' : ''}`}>
               <Outlet />
            </div>
         </div>
         {/* <div className="mobile-show at-text-dark">Coming soon for responsive devices</div> */}
         {openPrivacyPolicyModal && (
            <CustomModal
               show={openPrivacyPolicyModal}
               title={'Terms and conditions & Privacy Policy'}
               closeModal={() => setOpenPrivacyPolicyModal(false)}
               centered
               scrollable
               closeButton={false}
               backdrop="static"
               size={'lg'}>
               <div>
                  <div className="form-check">
                     <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexCheckDefault"
                        onChange={onClickReadPrivacyPolicy}
                     />
                     <label className="form-check-label">
                        By signing up you agree to our{' '}
                        <Link
                           to={'/terms-condition'}
                           target="_blank"
                           className="text-primary text-decoration-underline">
                           Terms and conditions
                        </Link>{' '}
                        and{' '}
                        <Link
                           to={'/privacy-policy'}
                           target="_blank"
                           className="text-primary text-decoration-underline">
                           Privacy policy.
                        </Link>
                     </label>
                  </div>
               </div>
            </CustomModal>
         )}
      </>
   )
}
